var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Socials/Youtube"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M27.2635 38.6699V24.2629L40.6453 31.4667L27.2635 38.6699ZM57.0299 19.7296C56.4411 17.6315 54.7061 15.9793 52.5034 15.4186C48.5106 14.3996 32.4999 14.3996 32.4999 14.3996C32.4999 14.3996 16.4892 14.3996 12.4964 15.4186C10.2935 15.9793 8.55854 17.6315 7.96979 19.7296C6.8999 23.5323 6.8999 31.4664 6.8999 31.4664C6.8999 31.4664 6.8999 39.4003 7.96979 43.2032C8.55854 45.3012 10.2935 46.9534 12.4964 47.5144C16.4892 48.5332 32.4999 48.5332 32.4999 48.5332C32.4999 48.5332 48.5106 48.5332 52.5034 47.5144C54.7061 46.9534 56.4411 45.3012 57.0299 43.2032C58.0999 39.4003 58.0999 31.4664 58.0999 31.4664C58.0999 31.4664 58.0999 23.5323 57.0299 19.7296Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.1c29c90f7b2309d9068b0993fdc7e923.svg";
export { ForwardRef as ReactComponent };